import { Button, Icon, Menu, MenuButton, MenuItem, MenuList, Text } from '@elkaso-app/web-design';
import { UnmatchedDemandSort } from 'apis/restaurant-inquiries';
import { usePageParams } from 'hooks/use-page-params';
import { BiChevronDown } from 'react-icons/bi';

// Every sort is single-direction server-side (↓ only, tie-break id ASC).
const SORT_LABELS: Record<UnmatchedDemandSort, string> = {
  inquiries: 'Inquiries',
  waiting_days: 'Waiting days',
  last_requested: 'Last requested',
};

export const SortMenu = () => {
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();
  const active = ((params.sort as string) || 'inquiries') as UnmatchedDemandSort;

  const apply = (sort: UnmatchedDemandSort) => {
    const next = { ...params };
    delete next.page;
    if (sort === 'inquiries') delete next.sort;
    else next.sort = sort;
    setPageParams(next);
  };

  return (
    <Menu>
      <MenuButton as={Button} size='sm' variant='ghost' color='gray.500' rightIcon={<Icon as={BiChevronDown} />}>
        Sort:{' '}
        <Text as='span' color='gray.800' fontWeight='semibold'>
          {SORT_LABELS[active] ?? SORT_LABELS.inquiries} ↓
        </Text>
      </MenuButton>
      <MenuList>
        {(Object.keys(SORT_LABELS) as UnmatchedDemandSort[]).map((sort) => (
          <MenuItem key={sort} fontWeight={sort === active ? 'bold' : 'normal'} onClick={() => apply(sort)}>
            {SORT_LABELS[sort]} ↓
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
